import { render } from "./NotesComponent.vue?vue&type=template&id=418d89eb"
import script from "./NotesComponent.vue?vue&type=script&lang=js"
export * from "./NotesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__